<script>
import { mapGetters, mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
    props:{
        serviceObject: {
            type: Object,
        },
        appointmentId: {
            type: String,
        }
    },
    emits:["resetModal", "refreshDetails"],
    data(){
        return{
            staffId: null, 
            staffList: [],
        }
    },
    methods: {
        ...mapActions('appointments', ['reassignStaffAppointment', 'fetchService']),
        async handleReassignStaff(){
            const payload = {
                staff_id: this.staffId
            }
            try{
                await this.reassignStaffAppointment({
                    appointmentId: this.appointmentId,
                    payload
                });
                useAlert(this.$t('APPOINTMENTS.REASSIGNSTAFFMODAL.SUCCESS_MESSAGE'));
                this.$emit("refreshDetails");
                this.$emit("resetModal");
            }catch(err){
                console.error(err);
                // The store throws the API's raw error body ({ detail }), not an
                // Error, so passing it to useAlert as-is showed "[object Object]".
                // On failure the modal stays open so the user can retry or cancel.
                useAlert(err?.detail || err?.message || this.$t('APPOINTMENTS.REASSIGNSTAFFMODAL.ERROR_MESSAGE'));
            }
        }
    },
    async mounted(){
        const response = await this.fetchService(this.serviceObject.service_id);
        this.staffList = response.staff;
    },
}
</script>

<template>
    <div data-testid="reassign_staff_modal" class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
        <label class="block">
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ $t('APPOINTMENTS.REASSIGNSTAFFMODAL.SELECT_STAFF_LABEL') }}</span>
            <select 
                data-testid="reassign_staff_select"
                v-model="staffId"
                class="w-full border rounded-md text-gray-900 dark:text-white dark:bg-slate-700 dark:border-gray-600 focus:ring-2 focus:ring-woot-500 focus:outline-none"
            >
                <option value="">{{ $t('APPOINTMENTS.REASSIGNSTAFFMODAL.SELECT_PLACEHOLDER') }}</option>
                <option v-for="staff in staffList" :key="staff.staff_id" :value="staff.staff_id">
                  {{ staff.staff_name }}
                </option>
            </select>
        </label>

        <div class="flex gap-2 mt-4">
            <woot-button
                data-testid="reassign_staff_cancel"
                variant="smooth"
                color-scheme="secondary"
                @click="$emit('resetModal')"
            >
                {{ $t('APPOINTMENTS.REASSIGNSTAFFMODAL.CANCEL_BUTTON') }}
            </woot-button>
            <button
                data-testid="reassign_staff_submit"
                :disabled="!staffId"
                @click="handleReassignStaff()"
                class="flex-1 py-2 text-white font-medium rounded-md transition bg-woot-600 hover:bg-woot-700 focus:ring-2 focus:ring-woot-400 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {{ $t('APPOINTMENTS.REASSIGNSTAFFMODAL.REASSIGN_BUTTON') }}
            </button>
        </div>
    </div>
</template>